import {getLocalSt, stKeys} from "./storage";

const toK = (value: number) => {
    if (value >= 1000) {
        let val = value.toString();
        return val.substring(0, val.length - 3).concat("k")
    }
    return value;
}

const addClassById = ({id, classAdd = "", classRemove = "", removedAfter = 0}) => {
    const doc = document.getElementById(id);
    if (doc) {
        if (classRemove) doc.classList.remove(classRemove);
        if (classAdd) doc.classList.add(classAdd);
        if (removedAfter > 0) setTimeout(() => {
            if (classAdd) doc.classList.remove(classAdd);
        }, removedAfter)
    }
}

const clickId = (id: string) => {
    let doc = document.getElementById(id);
    if (doc) doc.click();
}

const scrollTop = (id: string) => {
    let doc = document.getElementById(id);
    if (doc) {
        doc.scrollTop = 0;
    }
}

const removedAllClass = ({className}) => {
    let docs: HTMLCollectionOf<Element> = document.getElementsByClassName(className);
    if (docs.length > 0) {
        for (let i = 0; i < docs.length; i++) {
            docs[i].classList.remove(className)
        }
    }
}

const changeImgSrc = ({id, src = ""}) => {
    const doc = document.getElementById(id) as HTMLImageElement;
    if (doc) doc.src = src;
}

const isIframe = () => getLocalSt(stKeys.isIframe) === "1";


export {toK, addClassById, changeImgSrc, removedAllClass, scrollTop, clickId, isIframe}

